module.exports = __webpack_public_path__ + "img/user-ok.4ffd7c64.svg";